module.exports = __webpack_public_path__ + "img/euro.edb18350.svg";